import { Button, ButtonProps, Modal } from "antd"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { FC, forwardRef } from "react"
import "./index.less"

// Create a type for our custom props to separate them from standard Button props
type CustomButtonProps = {
  btnText?: string;
  btnType?: "primary" | "outline" | "ghost" | "decline";
};

// Use forwardRef to properly pass refs through the component
const CustomButton = forwardRef<HTMLButtonElement, CustomButtonProps & ButtonProps>(({
  btnText,
  btnType,
  className,
  // We don't need to destructure non-existent props, just use rest operator
  ...props
}, ref) => {
  // Use a clean className approach
  const buttonClassName = [
    className || '',
    btnType || '',
    'custom-button'
  ].filter(Boolean).join(' ');
  
  return (
    <Button 
      {...props} 
      className={buttonClassName}
      ref={ref}
    >
      {btnText}
    </Button>
  )
})

// Add displayName for better debugging
CustomButton.displayName = 'CustomButton';

export default CustomButton


const { confirm } = Modal;

const showConfirm = (title: string, content: string, onOk: () => void) => {
  confirm({
    title: title,
    icon: <ExclamationCircleFilled />,
    content: content,
    onOk() {
      onOk();
    },
    onCancel() {
      console.log('Cancel');
    },
  });
};

export { showConfirm };